import Loadable from 'react-loadable';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const RateRecommendedCandidateLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "RateRecommendedCandidate" */
      './RateRecommendedCandidate.dynamic'
    ),
  loading: LoadingPageLoadable,
});
